/* @flow weak */
import apiRequest from 'lib/apiRequest';

const POLL_INTERVAL = 1000; // ms

export const firstLastRequired = 'First and last name are both required';
export function handleDirectAddResponse(response) {
  const addedUsers = [];
  const existingUsers = [];
  const errorUsers = [];
  response.forEach(row => {
    const user = {
      fields: {
        name: [row.first_name, row.last_name].join(' '),
        address: row.address,
      },
      validation_errors: {},
    };

    if (row.was_added_to_org) {
      addedUsers.push(user);
    } else if (row.was_successful) {
      existingUsers.push(user);
    } else {
      row.validation_errors.forEach(error => {
        let key = null;
        let message = null;
        if (error.field_name === 'first_name' || error.field_name === 'last_name') {
          key = 'name';
          if (error.code === 'blank') {
            message = firstLastRequired;
          }
        } else {
          key = error.field_name;
        }
        user.validation_errors[key] = message || error.messages[0];
      });

      errorUsers.push(user);
    }
  });

  return {
    existingUsers,
    addedUsers,
    errorUsers,
  };
}

export function queryDirectAddJob(orgId, jobId, onUpdate) {
  return new Promise((resolve, reject) => {
    const poll = function() {
      apiRequest(`/organizations/${orgId}/teachers/job/${jobId}`)
        .then((response) => {
          if (onUpdate) {
            onUpdate(response);
          }
          if (response.status === 'complete') {
            resolve(handleDirectAddResponse(response.results));
          } else if (response.status === 'error') {
            reject(response.results);
          } else {
            setTimeout(poll, POLL_INTERVAL);
          }
        });
    };

    poll();
  });
}



// WEBPACK FOOTER //
// ./src/groups/lib/directAdd.js